import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp, faCirclePlus } from '@fortawesome/free-solid-svg-icons';

export default function AddCoordinateSection({ setShowAddCoordinateDropdown, showAddCoordinateDropdown, leaseSelectedColor,
    randomCoordenateValue, addCoordinateOnChange, setRandomCoordenateValue, setRandomCoordinateValueError, addCoordinate,
    randomCoordinateValueError, stationSelectedColor, secondRandomCoordenateValue, setSecondRandomCoordenateValue, setSecondRandomCoordinateValueError,
    secondRandomCoordinateValueError
}) {
    return (
        <div style={{ marginTop: "10px" }}>
            <div style={{ display: 'flex', width: 'fit-content', cursor: 'pointer' }} onClick={() => setShowAddCoordinateDropdown(!showAddCoordinateDropdown)}>
                <h2 style={{ "marginLeft": "11px"}}>
                    <strong>Add Coordinates</strong>
                </h2>
                <span style={{ position: "relative", "left": 10 }}>
                    <FontAwesomeIcon icon={showAddCoordinateDropdown ? faCaretUp : faCaretDown} />
                </span>
            </div>

            {
                showAddCoordinateDropdown &&
                <div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: "flex", height: "44px", marginTop: "10px", justifyContent: "space-between", width: "77%" }}>
                            <div style={{ display: "flex", width: '85%' }}>
                                {
                                    leaseSelectedColor ? <div style={
                                        { "width": 10, "height": 10, "backgroundColor": leaseSelectedColor, "marginTop": "19px", "marginLeft": "10px", "borderRadius": "15px" }
                                    } />
                                        : <div style={{ "width": 22 }} />
                                }
                                <input
                                    type='text'
                                    style={{ border: "1px solid grey", marginLeft: 10, borderRadius: "4px", width: '100%', paddingLeft: "7px" }}
                                    value={randomCoordenateValue}
                                    placeholder='Latitude, Longitude'
                                    onChange={e => addCoordinateOnChange(e.target.value, setRandomCoordenateValue, setRandomCoordinateValueError)}
                                />
                            </div>
                            <span style={{ position: "relative", "top": 10, "left": 15, cursor: "pointer" }} onClick={() => addCoordinate("first")}>
                                <FontAwesomeIcon icon={faCirclePlus} color="#04AA6D" size="2x" />
                            </span>

                        </div>
                        {
                            randomCoordinateValueError && (
                                <div>
                                    <p style={{ "marginLeft": "10px", color: 'red' }}>Coordinate not within USA</p>
                                </div>
                            )
                        }
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: "flex", "height": "50px", justifyContent: "space-between", width: "77%" }}>
                            <div style={{ display: "flex", width: '85%' }}>
                                {
                                    stationSelectedColor ? <div style={
                                        { "width": 10, "height": 10, "backgroundColor": stationSelectedColor, "marginTop": "25px", "marginLeft": "10px", "borderRadius": "15px" }
                                    } />
                                        : <div style={{ "width": 22 }} />

                                }
                                <input
                                    type='text'
                                    style={{ border: "1px solid grey", marginLeft: 10, marginTop: 10, borderRadius: "4px", width: '100%', paddingLeft: "7px" }}
                                    value={secondRandomCoordenateValue}
                                    placeholder='Latitude, Longitude'
                                    onChange={e => addCoordinateOnChange(e.target.value, setSecondRandomCoordenateValue, setSecondRandomCoordinateValueError)}
                                />
                            </div>
                            <span style={{ position: "relative", "top": 15, "left": 15, cursor: "pointer" }} onClick={() => addCoordinate("second")}>
                                <FontAwesomeIcon icon={faCirclePlus} color="#04AA6D" size="2x" />
                            </span>
                        </div>
                        {
                            secondRandomCoordinateValueError && (
                                <div>
                                    <p style={{ "marginLeft": "10px", color: 'red' }}>Coordinate not within USA</p>
                                </div>
                            )
                        }
                    </div>
                </div>
            }
        </div>
    )
}